import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import {
  clearCommAutomobileVehicleState,
  fetchCommAutomobileVehicleListAsync,
} from "../../../../../../redux/commAutoPolicy/commAutoVehicle/commAutoVehicleActions";

export const useCommAutoVehcileInfo = (
  customerPolicyId?: number,
  leadId?: string
) => {
  const dispatch = useDispatchWrapper();
  const { vehiclesList } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.vehicle.VehicleInformation
  );

  const vehcileDropdown = React.useMemo(() => {
    return vehiclesList.map((item) => {
      return {
        label: `${item.incremental_number || "--"} (VIN: ${
          item.vin || "N/A"
        }, Year: ${item.year}, Make: ${item.make}, Model: ${item.model} )`,
        value: String(item.incremental_number || ""),
      };
    });
  }, [vehiclesList]);

  const refreshData = () => {
    // Lead scope wins: fetch keyed by `lead_id`, never `customer_policy_id`.
    if (leadId) {
      dispatch(fetchCommAutomobileVehicleListAsync(0, undefined, leadId));
    } else if (customerPolicyId) {
      dispatch(fetchCommAutomobileVehicleListAsync(Number(customerPolicyId)));
    }
  };

  React.useEffect(() => {
    // Lead scope wins: fetch keyed by `lead_id`, never `customer_policy_id`.
    if (leadId) {
      dispatch(fetchCommAutomobileVehicleListAsync(0, undefined, leadId));
    } else if (customerPolicyId) {
      dispatch(fetchCommAutomobileVehicleListAsync(Number(customerPolicyId)));
    }
    return () => {
      dispatch(clearCommAutomobileVehicleState());
    };
  }, [customerPolicyId, leadId]);

  return { vehcileDropdown, vehiclesList, refreshData };
};
